import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import Parser from "html-react-parser";
import Modal from "react-bootstrap/Modal";
import TextoYTitulo from "@components/TextoYTitulo/TextoYTitulo";
import CardTypeFolder from "@components/CardTypeFolder/CardTypeFolder";
import Meta from "@components/Meta/Meta";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import { isEmpty, isUndefined } from "lodash";
import useMediaQuery from "app/hooks/useMediaQuery";
import "./Tarjetas.css";

const root = process.env.REACT_APP_CMS_STATIC;
const BORDER_TOP_COLOR = "#d7de00";

Tarjeta.propTypes = {
  dataCard: PropTypes.array,
};

//const root = process.env.REACT_APP_CMS_STATIC;

function Tarjeta({ dataCard = [], ...props }) {
  const is4K = useMediaQuery("(min-width: 3840px)");
  const isMobile = useMediaQuery("(max-width: 1023px)");

  const [card, setCard] = useState([]);
  const [titulo, setTitulo] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [rutaPrevia, setRutaPrevia] = useState("");
  const [textRutaPrevia, setTextRutaPrevia] = useState("");
  const [ruta, setRuta] = useState("");
  const [features, setFeatures] = useState([]);
  const [imagenTarjeta, setImagenTarjeta] = useState("");
  const [botones, setBotones] = useState([]);
  const [tips, setTips] = useState([]);
  const [showSecTips, setShowSecTips] = useState(false);
  const ROOT = process.env.REACT_APP_CMS_STATIC;
  const { tipsSeguridad } = useSelector(
    ({ AhorroYCredito }) => AhorroYCredito?.AhorroYCredito
  );

  /*const [detailTitleStyle, setDetailTitleStyle] = useState({
    minWidth: "225px",
    maxWidth: "75%",
    width: "fit-content",
  });*/

  const detailTitleStyle= {
    minWidth: "225px",
    maxWidth: "75%",
    width: "fit-content",
  };


  useEffect(() => {
    setCard(dataCard[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    !isEmpty(tipsSeguridad) && setTips(tipsSeguridad[0]?.bag?.contentItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tipsSeguridad]);

  useEffect(() => {
    if (!isEmpty(card)) {
      setRutaPrevia(card?.rutaPrevia[0]?.url);
      setTextRutaPrevia(card?.rutaPrevia[0]?.text);
      setRuta("/" + card?.nombre);
      setTitulo(card?.titulo);
      setDescripcion(card?.descripcion?.html);
      card?.bag.contentItems && setFeatures(card?.bag?.contentItems);
      setImagenTarjeta(root + card?.imagen?.urls[0]);
      card?.botones?.contentItems && setBotones(card?.botones?.contentItems);
    }
  }, [card]);

  const files =  card.archivosDescargables?.contentItems
  ? card.archivosDescargables?.contentItems.map(
      (file) => {
          return {
            fileName: file.tituloEnlace,
            fileURL: ROOT + file.archivo.urls[0],
          };
      }
   ) : [];

  const itemsBreadcrumb = () => {
    return !isUndefined(rutaPrevia)
      ? [{ url: rutaPrevia, text: textRutaPrevia }]
      : [{ url: ruta, text: titulo }];
  };

  const handleClose = () => setShowSecTips(false);
  const handleShow = () => setShowSecTips(true);

  const desktopContent = () => {
    const content =
      tips &&
      tips.map((tip, index) => {
        return (
          <div className="w-50" key={index}>
            <TextoYTitulo
              key={index}
              title=""
              text={
                "<div className='d-flex'><div><img src='" +
                root +
                tip?.icono?.urls[0] +
                "' width='32'/></div><div className='compact_tt ms-3'>" +
                tip?.descripcion?.html +
                "</div></div>"
              }
              borderTopColor="#D7DE00"
              heightsm={true}
            />
          </div>
        );
      });
    return content;
  };

  const mobileContent = () => {
    const content =
      tips &&
      tips.map((tip, index) => {
        return "<div className='d-flex'><div><img src='" +
                root +
                tip?.icono?.urls[0] +
                "' width='32'/></div><div className='compact_tt ms-3'>" +
                tip?.descripcion?.html +
                "</div></div>"              
      });
    return content.toString();

    //return "<div><p>Firme su tarjeta en el reverso del plástico.</p><p>No acepte ayuda de personas que no conozca cuando use el cajero automático, ni comparta su clave de identificación o PIN a terceros.</p><p>Evite llevar la clave de identificación en el mismo lugar que su tarjeta.</p><p>Conserve los vouchers cada vez que realice un pago en los comercios o cuando retire dinero de los cajeros automáticos.</p></div>";
  };

  return (
    <div className={is4K ? "contenedor pt-5 pb-4" : "pt-5 pb-4"}>
      <Meta
        title={titulo + " | Tarjetas | CS Ahorro y Crédito Costa Rica"}
        description={descripcion && descripcion}
        canonicalUrl={ruta}
      />
      <Breadcrumbs items={itemsBreadcrumb()} active={titulo} />

      <div>
        <h1 className="text-start mt-4 ms-5 me-5" style={{ color: "#001a70" }}>
          {titulo}
        </h1>
        <div
          className="text-start ms-5 me-5"
          style={{ fontSize: "24px", color: "#000" }}
        >
          {Parser(descripcion)}
        </div>
        <div className="info-cards-contenedor">
          {!isEmpty(features) &&
            features.map((feat, index) => {
              return (
                <CardTypeFolder
                  key={index}
                  title={feat?.title}
                  titleFullLength={true}
                  description={feat?.description?.html}
                  borderTopColor={BORDER_TOP_COLOR}
                />
              );
            })}
        </div>
        { files && files.length > 0 && (
         <div className="info-cards-contenedor">
            <CardTypeFolder
              titleStyle={detailTitleStyle}
              title="Documentos"
              description=""
              files={files}
              borderTopColor="#d7de00"
            />
         </div>
         )}
        <div className="img-and-btns-container">
          <div>
            {imagenTarjeta && (
              <img className="img-micro" src={imagenTarjeta} alt={titulo} />
            )}
          </div>
          <div className="btns-container">
            {!isEmpty(botones) &&
              botones.map((boton, index) => {
                return (
                  boton.ruta.text !== "Más Información" && (
                    <div className="mt-4" key={index}>
                      {boton.ruta.text === "Tips de Seguridad" ? (
                        <img
                          className="img img-fluid btn-micro"
                          key={index}
                          src={root + boton?.imagen?.urls[0]}
                          onClick={handleShow}
                          alt={boton?.ruta?.text}
                          style={{ cursor: "pointer" }}
                        />
                      ) : (
                        <a
                          href={boton?.ruta?.url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            className="img img-fluid btn-micro"
                            key={index}
                            src={root + boton?.imagen?.urls[0]}
                            alt={boton?.ruta?.text}
                          />
                        </a>
                      )}
                    </div>
                  )
                );
              })}
          </div>
        </div>
      </div>

      <Modal size="xl" show={showSecTips} onHide={handleClose}>
        <Modal.Header
          closeButton
          style={
            isMobile
              ? {
                  backgroundColor: "#f1f1f1",
                  borderBottom: "0px",
                  padding: "32px 34px 0px 32px",
                }
              : {
                  backgroundColor: "#f1f1f1",
                  borderBottom: "0px",
                  padding: "32px 66px 0px 60px",
                }
          }
        >
          <Modal.Title
            style={
              isMobile
                ? { fontSize: "22px", color: "#001a70" }
                : { fontSize: "36px", color: "#001a70" }
            }
          >
            Tips de Seguridad
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "#f1f1f1" }}>
          {isMobile ? (
            <div>
              <div className="w-100">
                <TextoYTitulo
                  title=""
                  text={mobileContent()}
                  borderTopColor="#D7DE00"
                  heightsm={true}
                />
              </div>
            </div>
          ) : (
            <div className="d-flex flex-wrap">{desktopContent()}</div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Tarjeta;
